import { OPEN_FORM, TOGGLE_MODAL, SET_GLOBAL_ACTIVITIES, SET_My_ACTIVITIES, SET_USER_INFO, SET_DASHBOARD_BASIC_DATA, GET_ACTIVITY_CATEGORIES, MANUALLY_SEND_EMAIL, MANUALLY_SEND_EMAIL_INCREMENT, RELOAD_ACTIVITIES, PEND_FEEDBACK_COUNT} from './actionName';

export const openFormAction = (name, activity , isEdit) => ({ type: OPEN_FORM , name: name, activity: activity, isEdit: isEdit })

export const toggleGlobalModalAction = (isShow) => ({ type: TOGGLE_MODAL, isShow })

export const setGlobelActivitiesAction = (activities = []) => ({ type: SET_GLOBAL_ACTIVITIES, activities })

export const setMyActivitiesAction = (activities = []) => ({ type: SET_My_ACTIVITIES, activities })

export const setUserInfoAction = (userInfo) => ({ type: SET_USER_INFO, userInfo })

export const setDashboardBasicDataAction = (basicDatas) => ({ type: SET_DASHBOARD_BASIC_DATA, basicDatas })

export const setActivityCategoriesAction = (categories) => ({ type: GET_ACTIVITY_CATEGORIES, categories})

export const manuallySentEmailAction = (activityId) => ({ type: MANUALLY_SEND_EMAIL, activityId })
export const manuallySentEmailIncrementAction = (activityId) => ({ type: MANUALLY_SEND_EMAIL_INCREMENT, activityId })

export const reloadActivitiesAction = (payload) => ({ type: RELOAD_ACTIVITIES, payload })

export const pendFeedbackCountAction = (payload) => ({ type: PEND_FEEDBACK_COUNT, payload })
